export default defineNuxtPlugin({
  name: 'monitoring',
  parallel: true,
  setup: () => {
    return {
      provide: {
        sentrySetContext: (_key: string, _value: Record<string, unknown>) => {},
        sentrySetUser: (_user?: unknown) => {},
        sentrySetTag: (_key: string, _value: string) => {},
        sentryAddBreadcrumb: (_breadcrumb: Record<string, unknown>) => {},
      },
    }
  },
})
